import SocialLinks from '../ui/SocialLinks/SocialLinks'
import { site } from '../../data/portfolio'
import styles from './Footer.module.css'

const Footer = () => (
  <footer className={styles.footer}>
    <div className={`container ${styles.inner}`}>
      <p className={styles.credit}>
        &copy; {new Date().getFullYear()} {site.title}. Designed &amp; built with
        React.
      </p>

      <SocialLinks size="sm" />
    </div>
  </footer>
)

export default Footer
